import { SpeedChart } from 'features/chart/SpeedChart';
import { Map } from 'features/map/Map';
import { withSegmentTooltip } from 'features/map/hooks/withSegmentTooltip';
import { TaskBar } from 'features/task_bar/TaskBar';
import { ChartSettings } from 'features/workflow_nrt/ChartSettings';
import {
  VisualisationRegion,
  WorkflowNrtSkeleton,
} from 'features/workflow_nrt/WorkflowRecent';
import { NoSegmentSelectedPanel } from 'features/workspace/NoSegmentSelectedPanel';

import { ReliesOn } from '../workflow_common/NoDataLoadedWarning';
import {
  WorkflowInfo,
  maybeCarryOverDates,
  maybeCarryOverRouteSelection,
  maybeCarryOverSelection,
} from '../workflow_common/workflowLookup';

export const workflowSpeed: WorkflowInfo = {
  dataAvailableReliesOn: [ReliesOn.nrtDay, ReliesOn.typicalMonth],
  switchToState: (fromWorkflow, state) => {
    // console.log('Handling switch from ', fromWorkflow, 'to', state.current, state);
    maybeCarryOverSelection(state, fromWorkflow);
    maybeCarryOverDates(state, fromWorkflow);
    maybeCarryOverRouteSelection(state, fromWorkflow);
  },
};
const MapWithTooltip = withSegmentTooltip(Map);

export function WorkflowSpeed() {
  return (
    <WorkflowNrtSkeleton
      vizRegionComponent={
        <VisualisationRegion
          graph_title="Speeds"
          unselected_state_fn={NoSegmentSelectedPanel}
        >
          <SpeedChart />
        </VisualisationRegion>
      }
      mapComponent={<MapWithTooltip enableRouteSelection />}
      taskBarComponent={
        <TaskBar segmentInfo="route" savedRoutes="regular">
          <ChartSettings />
        </TaskBar>
      }
    />
  );
}
